import React, { useState } from 'react';

function SurveyStepFour({ formData, onNext }) {
    const [gdprConfidence, setGdprConfidence] = useState(formData.gdprConfidence || '');
    const [gdprComments, setGdprComments] = useState(formData.gdprComments || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!gdprConfidence) {
            setError('Please select a rating.');
            return;
        }
        setError('');
        onNext({ gdprConfidence, gdprComments });
    };

    const ratingOptions = ['N/A', ...Array.from({ length: 10 }, (_, i) => (i + 1).toString())];

    return (
        <div className="step-form">
            <h6 className="mb-4">Section 1: Compliance & Training</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <label className="form-label">
                How confident are you about GDPR and data protection compliance? <span className="text-danger">*</span>
            </label>

            <div className="d-flex flex-wrap gap-2 mb-4 justify-content-around">
                {ratingOptions.map((option) => (
                    <div key={option} className="form-check rating_btn">
                        <input
                            type="radio"
                            id={`gdpr-rating-${option}`}
                            name="gdprConfidence"
                            value={option}
                            checked={gdprConfidence === option}
                            onChange={() => setGdprConfidence(option)}
                        />
                        <label htmlFor={`gdpr-rating-${option}`}>{option}</label>
                    </div>
                ))}
            </div>

            <div className="mb-3">
                <label className="form-label">Additional comments (optional):</label>
                <textarea
                    className="form-control"
                    rows="4"
                    value={gdprComments}
                    onChange={(e) => setGdprComments(e.target.value)}
                    placeholder="Share any additional thoughts here..."
                />
            </div>

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!gdprConfidence}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default SurveyStepFour;
